module.exports = __webpack_public_path__ + "img/no-user.5da8ee50.svg";